import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
{
    id: "po-06-h2v4-01",
    name: "PO 01 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 42, y: 226, width: 224, height: 404, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 274, y: 226, width: 247, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 274, y: 432, width: 247, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 611, y: 163, width: 314, height: 527, rotation: 0, imageRotation: 0 },
            { id: "5", x: 933, y: 163, width: 156, height: 260, rotation: 0, imageRotation: 0 },
            { id: "6", x: 933, y: 431, width: 156, height: 259, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h2v4-02",
    name: "PO 02 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 125, y: 164, width: 319, height: 527, rotation: 0, imageRotation: 0 },
        { id: "2", x: 622, y: 164, width: 341, height: 260, rotation: 0, imageRotation: 0 },
        { id: "3", x: 622, y: 432, width: 341, height: 259, rotation: 0, imageRotation: 0 },
        { id: "4", x: 971, y: 164, width: 103, height: 171, rotation: 0, imageRotation: 0 },
        { id: "5", x: 971, y: 343, width: 103, height: 170, rotation: 0, imageRotation: 0 },
        { id: "6", x: 971, y: 521, width: 103, height: 170, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-03",
    name: "PO 03 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 45, y: 226, width: 236, height: 404, rotation: 0, imageRotation: 0 },
        { id: "2", x: 289, y: 226, width: 235, height: 198, rotation: 0, imageRotation: 0 },
        { id: "3", x: 289, y: 432, width: 235, height: 198, rotation: 0, imageRotation: 0 },
        { id: "4", x: 668, y: 226, width: 242, height: 404, rotation: 0, imageRotation: 0 },
        { id: "5", x: 918, y: 226, width: 118, height: 198, rotation: 0, imageRotation: 0 },
        { id: "6", x: 918, y: 432, width: 118, height: 198, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-04",
    name: "PO 04 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 59, y: 90, width: 451, height: 334, rotation: 0, imageRotation: 0 },
        { id: "2", x: 59, y: 432, width: 451, height: 333, rotation: 0, imageRotation: 0 },
        { id: "3", x: 627, y: 90, width: 222, height: 334, rotation: 0, imageRotation: 0 },
        { id: "4", x: 627, y: 432, width: 222, height: 333, rotation: 0, imageRotation: 0 },
        { id: "5", x: 857, y: 90, width: 221, height: 334, rotation: 0, imageRotation: 0 },
        { id: "6", x: 857, y: 432, width: 221, height: 333, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-05",
    name: "PO 05 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 59, y: 90, width: 222, height: 334, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 289, y: 90, width: 221, height: 334, rotation: 0, imageRotation: 0 },
        { id: "3", x: 59, y: 432, width: 451, height: 333, rotation: 0, imageRotation: 0 },
        { id: "4", x: 627, y: 90, width: 451, height: 334, rotation: 0, imageRotation: 0 },
        { id: "5", x: 627, y: 432, width: 222, height: 333, rotation: 0, imageRotation: 0 },
        { id: "6", x: 857, y: 432, width: 221, height: 333, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-06",
    name: "PO 06 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 46, y: 159, width: 475, height: 339, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 46, y: 506, width: 113, height: 189, rotation: 0, imageRotation: 0 },
        { id: "3", x: 167, y: 506, width: 113, height: 189, rotation: 0, imageRotation: 0 },
        { id: "4", x: 288, y: 506, width: 113, height: 189, rotation: 0, imageRotation: 0 },
        { id: "5", x: 409, y: 506, width: 112, height: 189, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 245, width: 479, height: 365, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-07",
    name: "PO 07 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 47, y: 158, width: 154, height: 265, rotation: 0, imageRotation: 0 },
        { id: "2", x: 47, y: 431, width: 154, height: 265, rotation: 0, imageRotation: 0 },
        { id: "3", x: 209, y: 431, width: 153, height: 265, rotation: 0, imageRotation: 0 },
        { id: "4", x: 370, y: 431, width: 153, height: 265, rotation: 0, imageRotation: 0 },
        { id: "5", x: 209, y: 158, width: 314, height: 265, rotation: 0, imageRotation: 0 },
        { id: "6", x: 613, y: 245, width: 479, height: 365, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-08",
    name: "PO 08 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 568, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 628, y: 166, width: 333, height: 257, rotation: 0, imageRotation: 0 },
        { id: "3", x: 628, y: 431, width: 333, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 969, y: 166, width: 100, height: 169, rotation: 0, imageRotation: 0 },
        { id: "5", x: 969, y: 343, width: 100, height: 169, rotation: 0, imageRotation: 0 },
        { id: "6", x: 969, y: 520, width: 100, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-09",
    name: "PO 09 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 46, y: 272, width: 98, height: 151, rotation: 0, imageRotation: 0 },
        { id: "2", x: 46, y: 431, width: 98, height: 151, rotation: 0, imageRotation: 0 },
        { id: "3", x: 152, y: 272, width: 97, height: 151, rotation: 0, imageRotation: 0 },
        { id: "4", x: 152, y: 431, width: 97, height: 151, rotation: 0, imageRotation: 0 },
        { id: "5", x: 257, y: 272, width: 413, height: 310, rotation: 0, imageRotation: 0 },
        { id: "6", x: 678, y: 272, width: 413, height: 310, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-10",
    name: "PO 10 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 231, width: 449, height: 392, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 457, y: 231, width: 107, height: 192, rotation: 0, imageRotation: 0 },
        { id: "3", x: 457, y: 431, width: 107, height: 192, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 231, width: 106, height: 192, rotation: 0, imageRotation: 0 },
        { id: "5", x: 572, y: 431, width: 106, height: 192, rotation: 0, imageRotation: 0 },
        { id: "6", x: 686, y: 231, width: 450, height: 392, rotation: 0, imageRotation: 0 }
    ],
}
];